import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';
import ImportCsv from './ImportCsv';
import ExportCsv from './ExportCsv';

export { ImportCsv, ExportCsv };

export default {
  name: 'payouts',
  inputShow: gql`
    query payouts($input: PayoutQueryInput) {
      payouts(input: $input) {
        id
        assignment_id
        professional_id
        status
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'Billing',
    label: 'Payouts',
  },
};
